import { SuretyQuoteUnderwritingStatus } from "@inrev/common";
import { FC } from "react";
import { ProcessingBanner } from "./ProcessingBanner";

export type BondRequestProcessingBannerProps = {
	underwritingStatus?: SuretyQuoteUnderwritingStatus;
};

export const BondRequestProcessingBanner: FC<BondRequestProcessingBannerProps> = ({
	underwritingStatus,
}) => {
	if (underwritingStatus !== SuretyQuoteUnderwritingStatus.processing) {
		return null;
	}

	return (
		<ProcessingBanner
			testId="bond-request-processing-banner"
			title="Extracting and Analyzing Documents"
			description="Document data is being extracted and your request will be underwritten automatically once processing is complete."
		/>
	);
};
